import React from 'react';

import { Input as AntdInput } from 'antd';
import { SearchProps as AntdSearchProps } from 'antd/lib/input';
import classNames from 'classnames';

import useDebounce from 'hooks/debounce/useDebounce';
import { useSynchronizedState } from 'hooks/utils/useSynchronizedState';
import { DEBOUNCE_DELAY_DEFAULT } from 'utils/global';

import './SearchBar.less';

interface SearchBarProps {
  searchedStr: string | undefined;
  triggerSearch: (value?: string) => void;
  antdProps?: AntdSearchProps;
  className?: string;
  rounded?: boolean;
  delay?: number;
}

function SearchBar({
  searchedStr,
  triggerSearch,
  antdProps,
  className,
  rounded,
  delay = DEBOUNCE_DELAY_DEFAULT,
}: Readonly<SearchBarProps>): React.ReactElement {
  const [internalValue, setInternalValue] = useSynchronizedState(searchedStr);

  const debouncedSearch = useDebounce(triggerSearch, delay);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newValue = event.target.value;
    setInternalValue(newValue);
    debouncedSearch(newValue === '' ? undefined : newValue);
  }

  return (
    <AntdInput.Search
      {...antdProps}
      value={internalValue}
      onChange={onChange}
      onSearch={triggerSearch}
      className={classNames(
        rounded ? 'rounded-search-bar' : 'search-bar',
        className,
      )}
    />
  );
}

export default SearchBar;
